import createCache from '@emotion/cache';

export const createEmotionCache = ({ nonce }: { nonce?: string } = {}) => {
  return createCache({ key: 'css', nonce });
};
